/**
 * El alcance de un pedido: qué puede hacer con él quien lo mira, además de lo que le permite su rol.
 * Lo expone `OrderProvider` y lo aplica `useOpsRole`.
 */
import type { OrderRecord } from '@/types/operations.types';

/**
 * Qué puede hacer quien mira con este pedido, además de lo que le permite su rol.
 *
 * ⭐ EL PEDIDO ES EL MISMO PARA TODOS; LO QUE CAMBIA ES QUIÉN LO TOCA (founder, 25-sep, como Aliclik).
 *    · Lo abre por su PARTE (almacén o courier de un pedido ajeno): lo ve, no lo edita.
 *    · Es SUYO pero lo despacha otro (el proveedor de un encargo consignado): lo ve completo, no lo
 *      edita — la base ya lo frena (20260925159000); la pantalla no le ofrece lo que se rechazaría.
 */
export interface AlcanceDelPedido {
  soloLectura: boolean;
  motivo: 'propio' | 'por_mi_parte' | 'lo_despacha_otro';
}

export function alcanceDelPedido(order: OrderRecord | null, tenantId: string | null | undefined): AlcanceDelPedido {
  if (!order || !tenantId) return { soloLectura: false, motivo: 'propio' };
  if (order.tenant_id !== tenantId) return { soloLectura: true, motivo: 'por_mi_parte' };
  // Sólo el ENCARGO: la venta propia que despacha un almacén ajeno sigue siendo de quien la vendió.
  if (order.channel === 'smartydrop' && order.almacen_tenant_id && order.almacen_tenant_id !== order.tenant_id) {
    return { soloLectura: true, motivo: 'lo_despacha_otro' };
  }
  return { soloLectura: false, motivo: 'propio' };
}
